
namespace GeniuzPOS.ReportMasterData {
    import fld = Report_1201_RecvRow.Fields;
    @Serenity.Decorators.registerClass()
    export class Report_1201_RecvGrid extends Serenity.EntityGrid<Report_1201_RecvRow, any> {
        protected getColumnsKey() { return Report_1201_Recv2Columns.columnsKey; }
        protected getDialogType() { return Report_1201_RecvDialog; }
        protected getIdProperty() { return Report_1201_RecvRow.idProperty; }
        protected getInsertPermission() { return Report_1201_RecvRow.insertPermission; }
        protected getLocalTextPrefix() { return Report_1201_RecvRow.localTextPrefix; }
        protected getService() { return Report_1201_RecvService.baseUrl; }

        public mn: string;
        public year: string;
        public shop:string;
        public sup:string;

        private _date: string
        private _dateend: string

        constructor(container: JQuery) {
            super(container);
           
        }




        protected getColumns() {
            var columns = super.getColumns();

            return columns;
        }

        protected usePager() {
            return false;
        }

        protected createToolbarExtensions() {
            super.createToolbarExtensions();

            this.slickGrid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());

            var groupingMixin = new Serenity.DraggableGroupingMixin({
                grid: this
            });

            // setting ShipCountry, ShipCity columns as initially grouped for this sample
            // you could add [GroupOrder(1)] to ShipCountry, and [GroupOrder(2)] to ShipCity
            // in OrderColumns.cs instead (recommended way)
            groupingMixin.plugin.setDroppedGroups(["UpdateBy"]);
            // groupingMixin.plugin.setDroppedGroups(["PluCode"]);


        }
        protected getSlickOptions() {
            var opt = super.getSlickOptions();
            // need to turn grouping panel ON for drag drop grouping to work properly
            opt.groupingPanel = true;
            return opt;
        }

        protected markupReady() {
            super.markupReady();

            // expanding all level 0 (Country) and level 1 (City) groups initially
            this.view.expandAllGroups(0);
            // this.view.expandAllGroups(1);
            // this.view.expandAllGroups(2);

        }

        protected getButtons() {
            var buttons = super.getButtons();

            // remove first button (Add button)
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
            // buttons.splice(Q.indexOf(buttons, x => x.cssClass == 'column-picker-button'), 1)

            // Add buttons import excel, pdf
            buttons.push(Common.Helpers.ExcelExportHelper.createToolButton({
                grid: this,
                service: Report_1201_RecvService.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));

            
            // buttons.push(
            //     {
            //         title: Q.text("รายการเอกสาร"), // *** Get button text from translation
            //         cssClass: '.panel-pdf',
            //         icon: 'fa fa-file-pdf-o',
            //         onClick: () => {
            //             //var row = this.view.getRows();                        
            //         const request = this.getView().params as RecvData  //ReportDailyPIDetailData

                    



            //         request.Para = Q.tryFirst(Lookups.VwPsParaRow.getLookup().items, x=> x.Id == 1)
            //         request.DatetoDate = "วันที่เอกสาร :" + this.mn + " to " + this.year

            //         if(this.shop != null){
            //             let x = Q.tryFirst(InitialData.PsShopRow.getLookup().items, x => x.ShopId == this.shop )
            //             request.Shop = "ผู้จำหน่าย : " + this.shop + " - " + x.ShopName
            //         }else{
            //             request.Shop = "ผู้จำหน่าย : ทั้งหมด" 
            //         }


            //         if(this.sup != null){
            //             let x = Q.tryFirst(Supplier.CsSupplierRow.getLookup().items, x => x.SupplId == this.sup )
            //             request.Supdata = this.sup + " - " + x.SupplName
            //         }else{
            //             request.Supdata = ""
            //         }
                    
            //         request.Recv = this.view.getRows();                    

            //         // Q.postToService({ service: this.getService() + '/ExportPdf', request: request, target: '_blank' })
            //             // GeniuzPOS.Purchase.PoCNRTVService.GetNextNumber
                        
            //         },
               
            //     }
            // ); 

            return buttons
        }

        

        protected getQuickFilters() {
            var filters = super.getQuickFilters();

            Q.first(filters, x => x.field == fld.CreateDate).init = w => {

                (w as Serenity.DateEditor).valueAsDate = new Date(Date.now());

                let endDate = w.element.nextAll(".s-DateEditor").getWidget(Serenity.DateEditor);
                endDate.valueAsDate = new Date(Date.now());

                this._date = (w as Serenity.DateEditor).value
                this._dateend = endDate.value
            };

            // let t = Q.tryFirst(filters,x => x.field == fld.CreateDate)
            // console.log(t)
            // let p = t.handler
            // // console.log(t.handler.)
            // // console.log(t.handler.name)
            
           

            // // const branchFilter = Q.tryFirst(filters, x => x.field == fld.CreateDate)
            // // if (branchFilter) {
            //     t.handler = h => {
            //         // const el = h.widget.element.parent()[0];
            //         // if (el.classList.contains('d-none')) {
            //         //     return;
            //         // }
    
            //         this._date = h.value
            //         // h.request = this.updateListRequest(h.request)
            //         // h.active = !Q.isEmptyOrNull(this._date)
            //     }
            // // }
           
            //      console.log(this._date)

            return filters;
        }

        protected onViewSubmit() {
            // only continue if base class returns true (didn't cancel request)
            if (!super.onViewSubmit()) {
                return false;
            }
    
            // view object is the data source for grid (SlickRemoteView)
            // this is an EntityGrid so its Params object is a ListRequest
            var request = this.view.params as Serenity.ListRequest;

            let descriptions: string[] = [];

            if (request?.Criteria) {
                let criteria = request.Criteria.toString().split(',');
                let key: string = criteria[0];
                console.log(criteria)
                
                let d1 = criteria.findIndex(c => c == ">=");
                if (d1 >= 0) {
                    let v1 = criteria[d1 + 1];
                    let d2 = criteria.findIndex(c => c == "<");

                    console.log(v1)

                    if (d2 >= 0) {
                        let v2 = criteria[d2 + 1];
                        console.log(v2)
                        
                        descriptions.push(`${key}  ${Q.formatDate(v1, "dd/MM/yyyy"+' (00:00)')}  -  ${Q.formatDate(v2, "dd/MM/yyyy"+' (00:00)')}`);

                    } else {
                        descriptions.push(`${key}  ${Q.formatDate(v1, "dd/MM/yyyy")}`);
                    }
                } else {
                    let d2 = criteria.findIndex(c => c == "<");
                    if (d2 >= 0) {
                        let v2 = criteria[d2 + 1];
                        descriptions.push(`${key} ถึง  ${Q.formatDate(v2, "dd/MM/yyyy")}`);
                    }
                }
            } else {
                descriptions.push("วันที่ = ไม่ระบุ");
            }

    
            // console.log(request.Criteria)

            console.log(descriptions)
            // list request has a Criteria parameter
            // we AND criteria here to existing one because 
            // otherwise we might clear filter set by 
            // an edit filter dialog if any.
    
            // const fld = ProductRow.Fields;
            // request.Criteria = Serenity.Criteria.and(request.Criteria,
            //     Serenity.Criteria(fld.CreateDate).gt(10),
            //     Serenity.Criteria(fld.CategoryName).ne('Condiments'),
            //     Serenity.Criteria(fld.Discontinued).eq(0));
    
            return true;
        }

       


        protected createSlickGrid() {
            var grid = super.createSlickGrid();

        

            grid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());

            this.view.setSummaryOptions({
                aggregators: [

                    
                    // new Slick.Aggregators.Sum('AllItemDiscount'),
                    // new Slick.Aggregators.Sum('NetSales'),
                    new Slick.Aggregators.Sum('ReceiptAmt'),
                    new Slick.Aggregators.Sum('PointBurn'),
                    new Slick.Aggregators.Sum('CurrencyAmt'),

                ]

            });

            return grid;
        }


    }
}